import React from 'react'
import { getIcon } from '../getIcon'
import './CategoryHeader.scss'

interface IProps {
  title: string
  icon: string
  level: number
  linearGradient?: string
}

export function CategoryHeader({ title, icon, level, linearGradient }: IProps) {
  const iconImage = getIcon(icon)

  return (
    <div className="category-header-container">
      <div className="container">
        <div
          className="gradient-ring"
          style={{
            background: linearGradient,
          }}
        >
          <div className="inner-circle" />
          <img src={iconImage.x} alt={`${icon} icon`} />
        </div>
        <div className="labels">
          <div className="title">{title}</div>
          <div className="subtitle">Level {level}</div>
        </div>
      </div>
    </div>
  )
}
